import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/examples/jsm/geometries/RoundedBoxGeometry.js';
import {
  accentMaterial,
  bodyMaterial,
  createMotes,
  createPedestal,
  extrude,
  gearShape,
  glowMaterial,
  PortalScene,
  SceneFactory,
} from './portal-scene';

function shieldShape(): THREE.Shape {
  const shape = new THREE.Shape();
  shape.moveTo(0, 1.3);
  shape.lineTo(-1.0, 0.82);
  shape.lineTo(-1.0, -0.2);
  shape.quadraticCurveTo(-0.96, -1.02, 0, -1.46);
  shape.quadraticCurveTo(0.96, -1.02, 1.0, -0.2);
  shape.lineTo(1.0, 0.82);
  shape.closePath();
  return shape;
}

/** Admin: a hardened shield carrying a rotating configuration gear. */
export const createAdminScene: SceneFactory = (accent): PortalScene => {
  const root = new THREE.Group();

  const pivot = new THREE.Group();
  root.add(pivot);

  const shield = new THREE.Mesh(extrude(shieldShape(), 0.34, 0.08), bodyMaterial(0x4454a6));
  pivot.add(shield);

  const plate = new THREE.Mesh(extrude(shieldShape(), 0.2, 0.05), accentMaterial(accent, 0.34));
  plate.scale.setScalar(0.78);
  plate.position.z = 0.22;
  pivot.add(plate);

  const gear = new THREE.Mesh(extrude(gearShape(0.55, 0.2, 10, 0.15), 0.18, 0.03), bodyMaterial(0x263163));
  gear.position.z = 0.46;
  pivot.add(gear);

  const hub = new THREE.Mesh(new THREE.CylinderGeometry(0.14, 0.14, 0.3, 32), accentMaterial(accent, 1.4));
  hub.rotation.x = Math.PI / 2;
  hub.position.z = 0.52;
  pivot.add(hub);

  const orbit = new THREE.Group();
  const keyGeometry = new RoundedBoxGeometry(0.3, 0.3, 0.3, 4, 0.07);
  for (let i = 0; i < 3; i++) {
    const node = new THREE.Mesh(keyGeometry, accentMaterial(accent, 0.85));
    const angle = (i / 3) * Math.PI * 2;
    node.position.set(Math.cos(angle) * 1.62, Math.sin(angle) * 0.55, Math.sin(angle) * 1.62);
    orbit.add(node);
  }
  root.add(orbit);

  const sweep = new THREE.Mesh(new THREE.TorusGeometry(1.68, 0.016, 12, 120, Math.PI * 1.1), glowMaterial(accent, 0.6));
  sweep.rotation.x = Math.PI / 2.2;
  root.add(sweep);

  const motes = createMotes(accent, 12, 2.0);
  root.add(motes, createPedestal(accent));

  return {
    root,
    update(elapsed, hover) {
      pivot.position.y = Math.sin(elapsed * 1.1) * 0.08 + hover * 0.12;
      pivot.rotation.z = Math.sin(elapsed * 0.7) * 0.05;
      gear.rotation.z = elapsed * (0.6 + hover * 1.9);
      orbit.rotation.y = elapsed * (0.35 + hover * 0.9);
      sweep.rotation.z = -elapsed * 0.5;
      motes.rotation.y = elapsed * 0.14;
    },
  };
};
